import React from 'react';
import { Typography, Button, Row, Col, Card, Space, Divider } from 'antd';
import { useNavigate } from 'react-router-dom';
import { 
  SmileOutlined, 
  LineChartOutlined, 
  RobotOutlined, 
  SafetyOutlined, 
  FireOutlined 
} from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Title, Paragraph } = Typography;

const HomePage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const features = [
    {
      icon: <SmileOutlined style={{ fontSize: '36px', color: '#1890ff' }} />,
      title: '情绪记录',
      description: '记录每天的情绪变化，包括情绪类型、强度以及关联事件'
    },
    {
      icon: <LineChartOutlined style={{ fontSize: '36px', color: '#52c41a' }} />,
      title: '趋势分析',
      description: '通过图表直观展示情绪变化趋势，帮助您了解自己的情绪模式'
    },
    {
      icon: <RobotOutlined style={{ fontSize: '36px', color: '#fa8c16' }} />,
      title: 'AI情绪分析',
      description: '基于先进的人工智能技术，提供个性化的情绪洞察和建议'
    },
    {
      icon: <SafetyOutlined style={{ fontSize: '36px', color: '#eb2f96' }} />,
      title: '数据安全',
      description: '严格的数据保护措施，确保您的情绪记录和个人信息安全可靠'
    }
  ];

  return (
    <div className="container">
      {/* 英雄区 */}
      <div style={{ textAlign: 'center', padding: '60px 0' }}>
        <Title>探索您的情绪世界</Title>
        <Paragraph style={{ fontSize: '18px', marginBottom: '30px' }}>
          记录、分析和理解您的情绪变化，促进心理健康
        </Paragraph>
        <Space size="large">
          {isAuthenticated ? (
            <Button type="primary" size="large" icon={<FireOutlined />} onClick={() => navigate('/dashboard')}>
              进入仪表盘
            </Button>
          ) : (
            <>
              <Button type="primary" size="large" onClick={() => navigate('/register')}>
                立即注册
              </Button>
              <Button size="large" onClick={() => navigate('/login')}>
                登录
              </Button>
            </>
          )}
        </Space>
      </div>

      <Divider />

      {/* 功能特点 */}
      <div style={{ padding: '40px 0' }}>
        <Title level={2} style={{ textAlign: 'center', marginBottom: '40px' }}>
          主要功能
        </Title>
        <Row gutter={[32, 32]}>
          {features.map((feature, index) => (
            <Col xs={24} sm={12} lg={6} key={index}>
              <Card 
                hoverable 
                style={{ height: '100%', textAlign: 'center' }}
                styles={{
                  body: { display: 'flex', flexDirection: 'column', height: '100%' }
                }}
              >
                <div style={{ marginBottom: '20px' }}>{feature.icon}</div>
                <Title level={4}>{feature.title}</Title>
                <Paragraph>{feature.description}</Paragraph>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      <Divider />

      {/* 使用场景 */}
      <div style={{ padding: '40px 0' }}>
        <Title level={2} style={{ textAlign: 'center', marginBottom: '30px' }}>
          为什么使用情绪记录应用
        </Title>
        <Row gutter={[32, 32]} align="middle">
          <Col xs={24} md={12}>
            <img 
              src="https://images.unsplash.com/photo-1599420186946-7b6fb4e297f0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=80" 
              alt="情绪健康"
              style={{ width: '100%', borderRadius: '8px' }}
            />
          </Col>
          <Col xs={24} md={12}>
            <Title level={3}>提升情绪意识</Title>
            <Paragraph style={{ fontSize: '16px' }}>
              记录情绪是提升情绪意识的第一步。通过定期跟踪情绪状态，您可以识别情绪模式、触发因素以及应对策略，从而更好地理解自己的心理健康状况。
            </Paragraph>
            <Paragraph style={{ fontSize: '16px' }}>
              我们的应用提供了简单易用的界面，帮助您轻松记录日常情绪变化，并通过AI分析获得个性化洞察。
            </Paragraph>
          </Col>
        </Row>
      </div>

      {/* 行动召唤 */}
      <div style={{ textAlign: 'center', padding: '60px 0' }}>
        <Title level={2}>开始您的情绪探索之旅</Title>
        <Paragraph style={{ fontSize: '16px', marginBottom: '30px' }}>
          每一次记录都是自我了解的一步，现在就开始吧
        </Paragraph>
        {isAuthenticated ? (
          <Button type="primary" size="large" onClick={() => navigate('/emotion-records/create')}>
            记录新情绪
          </Button>
        ) : (
          <Button type="primary" size="large" onClick={() => navigate('/register')}>
            免费注册
          </Button>
        )}
      </div>
    </div>
  );
};

export default HomePage; 